import { render, staticRenderFns } from "./tasksEdit.vue?vue&type=template&id=21a0c830&scoped=true&"
import script from "./tasksEdit.vue?vue&type=script&lang=js&"
export * from "./tasksEdit.vue?vue&type=script&lang=js&"
import style0 from "./tasksEdit.vue?vue&type=style&index=0&id=21a0c830&lang=less&scoped=true&"
import style1 from "./tasksEdit.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21a0c830",
  null
  
)

component.options.__file = "tasksEdit.vue"
export default component.exports